import { useState, useEffect } from "react";
import {
  Group,
  Container,
  Text,
  Stack,
  Grid,
  TextInput,
  Center,
  Loader,
  Button,
  Textarea,
  TagsInput,
} from "@mantine/core";
import { updatePrompt, getSinglePrompt } from "../../api";
import { useForm } from "@mantine/form";
import { useLocation } from "wouter";

export default function PromptEdit({ params }) {
  const [prompt, setPrompt] = useState(null);
  const [, setLocation] = useLocation();

  useEffect(() => {
    getSinglePrompt(params.id).then((data) => {
      setPrompt(data);
      form.setValues({
        promptText: data.promptText,
        description: data.description,
        tags: data.tags || [],
        title: data.title,
      });
    });
    // Mantine form object has unstable identity; including it would rerun this effect every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const updatePromptHandler = (data) => {
    updatePrompt(params.id, data).then((response) => {
      setLocation(`/prompts/${response.id}`);
    });
  };

  const form = useForm({
    mode: "uncontrolled",
  });

  if (!prompt)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  return (
    <Container px={0}>
      <Grid justify="space-between">
        <Grid.Col span={12}>
          <Text mb="sm" fw={500}>
            {prompt.title}
          </Text>

          <form onSubmit={form.onSubmit(updatePromptHandler)}>
            <Stack>
              <TextInput
                {...form.getInputProps("title")}
                key={form.key("title")}
                label="Title"
                placeholder="My Clever Prompt"
              />
              <Textarea
                {...form.getInputProps("description")}
                key={form.key("description")}
                label="Description"
                autosize
                minRows={2}
                maxRows={5}
                placeholder="A prompt to find the meaning of life"
              />

              <TagsInput {...form.getInputProps(`tags`)} label="Tags" />

              {/* {form.getValues().tags?.map((item, index) => (
              <Group key={item} mt="xs" align="flex-end">
                <TextInput
                  style={{ flex: 1 }}
                  {...form.getInputProps(`tags.${index}`)}
                  key={form.key(`tags.${index}`)}
                  label="Tag"
                />
                <ActionIcon
                  color="red"
                  variant="outline"
                  onClick={() => form.removeListItem("tags", index)}
                >
                  <IconTrash size="1rem" />
                </ActionIcon>
              </Group>
            ))}

            <Button
              mt="xs"
              onClick={() => form.insertListItem("tags", "")}
            >
              Add Tag
            </Button> */}

              <Textarea
                {...form.getInputProps("promptText")}
                key={form.key("promptText")}
                label="Prompt"
                autosize
                minRows={5}
                maxRows={20}
                radius="md"
              />

              <Group justify="flex-end">
                <Button type="submit" mt="md">
                  Save
                </Button>
              </Group>
            </Stack>
          </form>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
